import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../classes/customer';

@Pipe({
  name: 'customerEnabledFilter',
  pure: false
})
export class CustomerEnabledFilterPipe implements PipeTransform {

  transform(customerList: Array<Customer>, filterValues: string[]): any {
    if (!customerList || !filterValues?.length) {
      return customerList;
    }

    const normalizedFilters = new Set(filterValues.map(value => value.toLowerCase()));
    return customerList.filter(customer => {
      const label = customer.Enabled ? 'attivo' : 'disabilitato';
      return normalizedFilters.has(label);
    });
  }

}
